import { render, staticRenderFns } from "./gatewaycheckinghealthmodal.vue?vue&type=template&id=0a48625c&scoped=true"
import script from "./gatewaycheckinghealthmodal.vue?vue&type=script&lang=js"
export * from "./gatewaycheckinghealthmodal.vue?vue&type=script&lang=js"
import style0 from "./gatewaycheckinghealthmodal.vue?vue&type=style&index=0&id=0a48625c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48625c",
  null
  
)

export default component.exports